/**
 * AB Flag Names Constants
 * These constants should match the flag names in DynamoDB schema
 */

export const AB_FLAGS = {
    LOWER_HOUSEHOLD_INCOME_LIMIT: 'lowerHouseholdIncomeLimit',
} as const;

// Type for AB flag names
export type ABFlagName = (typeof AB_FLAGS)[keyof typeof AB_FLAGS];
